// extracted by mini-css-extract-plugin
export default {"layout":"BillingPage_layout__+ofU0","flexContainer":"BillingPage_flexContainer__F4CZe"};